import React from 'react';
import { Link } from 'react-router-dom';
import SearchPopUp from './SearchPopUp';

const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Pricing',         to: '/pricing' },
      { label: 'How it works',    to: '/how-textlink-works' },
      { label: 'GoHighLevel',     to: '/ghl' },
      { label: 'REST API',        to: '/smsapi' },
      { label: 'Bulk SMS',        to: '/bulksms' },
      { label: 'Web inbox',       to: '/web-sms-app' }
    ]
  },
  {
    title: 'Resources',
    links: [
      { label: 'FAQ',             to: '/faq' },
      { label: 'Contact',         to: '/Contact' },
      { label: 'Guides',          to: '/guides' },
      { label: 'Download APK',    to: 'https://textlinksms.com/textlink.apk', external: true },
      { label: 'Roadmap',         to: '/roadmap' },
      { label: 'Affiliate',       to: '/affiliate-program' }
    ]
  },
  {
    title: 'Industries',
    links: [
      { label: 'Trucking',        to: '/trucking' },
      { label: 'Marketing',       to: '/sms-marketing' },
      { label: 'SaaS',            to: '/saas' }
    ]
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of service', to: '/tos' },
      { label: 'Privacy policy',   to: '/privacy-policy' },
      { label: 'Cookies',          to: '/cookies' }
    ]
  }
];

const SOCIALS = [
  {
    label: 'Discord',
    href: 'https://discord.gg/AR9Ypx3EBK',
    svg: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.3 4.4A19.4 19.4 0 0 0 15.6 3l-.2.4a18 18 0 0 0-6.8 0L8.4 3a19.4 19.4 0 0 0-4.7 1.4C1.4 8 .7 11.5 1 14.9a19.5 19.5 0 0 0 5.9 3l1.2-1.6a12.6 12.6 0 0 1-2-1 .1.1 0 0 1 0-.1l.4-.3a13.9 13.9 0 0 0 11 0l.4.3a.1.1 0 0 1 0 .2 12.6 12.6 0 0 1-2 1L17 17.9a19.5 19.5 0 0 0 5.9-3c.4-3.9-.4-7.4-2.6-10.5ZM8.3 13.3c-1.2 0-2.1-1-2.1-2.3s.9-2.3 2.1-2.3 2.1 1 2.1 2.3-.9 2.3-2.1 2.3Zm7.4 0c-1.2 0-2.1-1-2.1-2.3s1-2.3 2.1-2.3c1.2 0 2.1 1 2.1 2.3s-.9 2.3-2.1 2.3Z"/>
      </svg>
    )
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/textlink',
    svg: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.4 3H3.6C3.3 3 3 3.3 3 3.6v16.8c0 .3.3.6.6.6h16.8c.3 0 .6-.3.6-.6V3.6c0-.3-.3-.6-.6-.6ZM8.3 18.4H5.6V9.7h2.7v8.7ZM7 8.5a1.5 1.5 0 1 1 0-3.1 1.5 1.5 0 0 1 0 3.1Zm11.4 9.9h-2.7V14c0-1 0-2.3-1.4-2.3-1.4 0-1.6 1.1-1.6 2.2v4.5H10V9.7h2.6v1.2a2.9 2.9 0 0 1 2.6-1.4c2.8 0 3.3 1.8 3.3 4.2v4.7Z"/>
      </svg>
    )
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@TextLink',
    svg: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M23.5 6.2a3 3 0 0 0-2.1-2.2C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.5a3 3 0 0 0-2.1 2.2A31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.2c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.2 31.5 31.5 0 0 0 .5-5.8 31.5 31.5 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.3 3.6-6.3 3.6Z"/>
      </svg>
    )
  }
];

export default function FooterOne() {
  return (
    <>
      <footer className="tl-foot">
        <div className="tl-foot-container">
          <div className="tl-foot-grid">
            {/* Brand column */}
            <div className="tl-foot-brand">
              <Link to="/" className="tl-foot-logo">
                <img src="/assets/img/logo/logo2.png" alt="" className="tl-foot-logo-mark" />
                <span className="tl-foot-logo-text">TextLink</span>
              </Link>
              <p className="tl-foot-tagline">
                Send SMS from your own phone, at carrier cost.
              </p>
            </div>

            {/* Link columns */}
            {COLUMNS.map((col) => (
              <div key={col.title} className="tl-foot-col">
                <h4>{col.title}</h4>
                <ul>
                  {col.links.map((l) => (
                    <li key={l.to}>
                      {l.external
                        ? <a href={l.to} target="_blank" rel="noopener noreferrer">{l.label}</a>
                        : <Link to={l.to}>{l.label}</Link>}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="tl-foot-bottom">
            <div className="tl-foot-copy">
              © {new Date().getFullYear()} TextLink LTD
            </div>
            <div className="tl-foot-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="tl-foot-social"
                >
                  {s.svg}
                </a>
              ))}
            </div>
            <div className="tl-foot-status">
              <span className="tl-foot-dot" /> All systems operational
            </div>
          </div>
        </div>

        <style>{`
          .tl-foot {
            background: #ffffff;
            color: #787774;
            border-top: 1px solid #e9e9e7;
            padding: 56px 24px 28px;
            font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, sans-serif;
            -webkit-font-smoothing: antialiased;
            font-size: 14px;
            line-height: 1.55;
          }
          .tl-foot-container {
            max-width: 1100px;
            margin: 0 auto;
          }

          .tl-foot-grid {
            display: grid;
            grid-template-columns: 1.4fr repeat(4, 1fr);
            gap: 40px;
            padding-bottom: 36px;
          }
          @media (max-width: 960px) {
            .tl-foot-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
            .tl-foot-brand { grid-column: span 2; }
          }
          @media (max-width: 560px) {
            .tl-foot-grid { grid-template-columns: 1fr; gap: 28px; }
            .tl-foot-brand { grid-column: span 1; }
          }

          /* Brand column */
          .tl-foot-logo {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            text-decoration: none;
            color: #37352f;
            margin-bottom: 12px;
          }
          .tl-foot-logo-mark {
            width: 22px; height: 22px;
            object-fit: contain;
          }
          .tl-foot-logo-text {
            font-size: 15px;
            font-weight: 600;
            letter-spacing: -0.01em;
            color: #37352f;
          }
          .tl-foot-tagline {
            font-size: 14px;
            line-height: 1.55;
            margin: 0;
            color: #787774;
            max-width: 260px;
          }

          /* Link columns */
          .tl-foot-col h4 {
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            color: #9b9a97;
            margin: 0 0 12px;
          }
          .tl-foot-col ul {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          .tl-foot-col a {
            color: #787774;
            text-decoration: none;
            font-size: 14px;
            transition: color 120ms ease;
          }
          .tl-foot-col a:hover {
            color: #37352f;
          }

          /* Bottom bar */
          .tl-foot-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 16px;
            padding-top: 20px;
            border-top: 1px solid #e9e9e7;
            font-size: 13px;
            color: #9b9a97;
          }

          .tl-foot-socials {
            display: inline-flex;
            gap: 12px;
          }
          .tl-foot-social {
            color: #9b9a97;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: color 120ms ease;
          }
          .tl-foot-social:hover {
            color: #37352f;
          }

          .tl-foot-status {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 13px;
            color: #9b9a97;
          }
          .tl-foot-dot {
            width: 6px; height: 6px;
            border-radius: 50%;
            background: #16a34a;
          }

          @media (max-width: 640px) {
            .tl-foot-bottom { justify-content: center; text-align: center; }
            .tl-foot-copy, .tl-foot-status { flex: 1 1 100%; }
            .tl-foot-socials { flex: 1 1 100%; justify-content: center; }
          }
        `}</style>
      </footer>
      <SearchPopUp />
    </>
  );
}
